(() => {
  if (window.EmslandrostDelivery) { window.EmslandrostDelivery.init(document); return; }
  const instances = new Map();
  const hasContent = node => {
    if (!node) return false;
    const copy = node.cloneNode(true);
    copy.querySelectorAll('script,style,template,noscript').forEach(x => x.remove());
    return Boolean(copy.textContent.trim());
  };
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-em-delivery]')];
    if (scope.matches?.('[data-em-delivery]')) roots.push(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      let values;
      try { values = JSON.parse(root.querySelector('[data-em-delivery-values]').textContent); } catch { return; }
      const native = root.querySelector('[data-em-delivery-native]');
      const value = root.querySelector('[data-em-delivery-value]');
      const legacy = root.querySelector('[data-em-delivery-legacy]');
      let legacyPending = false;
      const update = () => {
        const html = values[root.dataset.variantId] || '';
        // Values are escaped/rendered by Liquid; never construct delivery promises in JS.
        if (value.innerHTML !== html) value.innerHTML = html;
        native.hidden = !html;
        const legacyVariant = legacy?.querySelector('[data-mg-variant-id]')?.getAttribute('data-mg-variant-id');
        const legacyReady = !legacyPending || legacyVariant === root.dataset.variantId;
        if (legacy) legacy.hidden = Boolean(html) || !root.dataset.variantId || !legacyReady;
        root.hidden = !root.dataset.variantId || (!html && (!legacyReady || !hasContent(legacy)));
      };
      const observer = legacy ? new MutationObserver(update) : null;
      observer?.observe(legacy, { childList: true, subtree: true, characterData: true });
      instances.set(root, { update, observer, select(id) { legacyPending = true; root.dataset.variantId = id; update(); } });
      update();
    });
  }
  document.addEventListener('on:variant:change', event => {
    const picker = event.target.closest?.('variant-picker');
    if (picker?.dataset.updateUrl === 'false' || picker?.closest('quick-add-drawer, quick-add, .quick-add')) return;
    const productId = event.detail?.product?.id;
    if (!productId) return;
    instances.forEach((instance, root) => {
      if (root.dataset.productId !== String(productId)) return;
      instance.select(event.detail?.variant?.id ? String(event.detail.variant.id) : '');
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.observer?.disconnect(); instances.delete(root); }
    });
  });
  window.EmslandrostDelivery = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
